import { render, staticRenderFns } from "./DetalheHistoricoLeads.vue?vue&type=template&id=57aaf631&scoped=true&"
import script from "./DetalheHistoricoLeads.vue?vue&type=script&lang=js&"
export * from "./DetalheHistoricoLeads.vue?vue&type=script&lang=js&"
import style0 from "./DetalheHistoricoLeads.vue?vue&type=style&index=0&id=57aaf631&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57aaf631",
  null
  
)

export default component.exports